import { z } from 'zod';

export const PermissionRoleSchema = z.enum(['editor', 'viewer', 'no_access']);

export const UniqueItemSchema = z.object({
  id: z.string(),
  label: z.string(),
});

export const DimensionFormatTypeSchema = z.enum([
  // TODO: LEGACY DIMENSIONS FORMAT TYPES. SHOULD BE REMOVED ONCE ALL DASHBOARDS ARE MIGRATED TO MINT 2.0 REPORTING SERVICE (reportingMint2Next)
  'STRING',
  'LONG',
  'Label',
  'Main',
  'Tag',
  'Category',
  'BuyingPlan',
  'MediaRow',
  'Currency',
  'Brands',
  'Activity',
  'Budget',
  // Leave only this dimensions types
  'hierarchy',
  'media_row',
  'budgeting_level',
  'timestamp',
  'fact',
  'main',
]);

export const DimensionBaseItemSchema = z.object({
  id: z.string(),
  dimensionType: DimensionFormatTypeSchema,
  label: z.string(),
});

export const DimensionItemSchema = DimensionBaseItemSchema.extend({
  uniques: z.array(UniqueItemSchema).nullish().default([]),
});

export const MetricFormatSchema = z.enum([
  'number',
  'money',
  'percent',
  'date',
  'string',
  'object',
]);

export const MetricValueTypeSchema = z.enum([
  'percent',
  'decimal',
  'double',
  'static-metric',
  'long',
  'multi-currency',
  'buying-plan-multi-currency',
  'json',
  'string',
]);

export const MetricSourceTypeSchema = z.enum(['planned', 'actual']);

export const MetricBaseItemSchema = z.object({
  id: z.string(),
  label: z.string(),
  format: MetricFormatSchema,
  valueType: MetricValueTypeSchema,
  metricType: MetricSourceTypeSchema.optional(),
  isBPStringMetric: z.boolean().optional(),
  mdmFieldId: z.string().nullish(),
});

export const MetricItemSchema = MetricBaseItemSchema.extend({
  uniques: z.array(UniqueItemSchema).optional(),
});

export const MetricScaleSchema = z.enum([
  'day',
  'week',
  'month',
  'quarter',
  'year',
  'all',
]);

export const ComparisonPeriodSchema = z
  .enum(['week', 'month', 'three-month', 'six-month', 'year', 'custom'])
  .nullable();

export const FormattedCurrencySchema = z.union([
  z.object({
    literal: z.string(),
    name: z.string(),
    id: z.string(),
    label: z.string(),
    selected: z.boolean().optional(),
  }),
  z.object({
    name: z.literal('default'),
    id: z.literal('0'),
    literal: z.literal(''),
    label: z.literal('USD'),
    selected: z.boolean().optional(),
  }),
]);
